var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ef70341"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "columns is-mobile" };
const _hoisted_4 = { class: "column" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Citizen", -1));
const _hoisted_6 = {
    key: 0,
    class: "column"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Birth State", -1));
const _hoisted_8 = { class: "columns is-mobile" };
const _hoisted_9 = { class: "column" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Partner", -1));
const _hoisted_11 = { class: "column" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Site", -1));
const _hoisted_13 = { class: "columns is-mobile" };
const _hoisted_14 = { class: "column" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Case Worker", -1));
const _hoisted_16 = { key: 0 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = { key: 1 };
const _hoisted_20 = { class: "columns is-mobile" };
const _hoisted_21 = { class: "columns is-mobile" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_23 = { key: 1 };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_26 = [
    _hoisted_25
];
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { class: "columns is-mobile" };
const _hoisted_29 = { class: "columns is-mobile" };
const _hoisted_30 = { class: "columns is-mobile" };
const _hoisted_31 = { class: "columns is-mobile" };
const _hoisted_32 = { class: "columns is-mobile" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_34 = { key: 2 };
const _hoisted_35 = { key: 0 };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_37 = [
    _hoisted_36
];
const _hoisted_38 = { key: 1 };
const _hoisted_39 = { class: "columns is-mobile" };
const _hoisted_40 = { class: "columns is-mobile" };
const _hoisted_41 = { class: "columns is-mobile" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_43 = { key: 3 };
const _hoisted_44 = { key: 0 };
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_46 = [
    _hoisted_45
];
const _hoisted_47 = { key: 1 };
const _hoisted_48 = { class: "control is-expanded" };
const _hoisted_49 = { class: "control is-expanded" };
const _hoisted_50 = { class: "control" };
const _hoisted_51 = ["onClick"];
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1));
const _hoisted_53 = [
    _hoisted_52
];
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_55 = { key: 4 };
const _hoisted_56 = { key: 0 };
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "notification bulmaNotification is-info" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "This application is archived, and detailed information has been purged to protect the privacy of the citizen.")
], -1));
const _hoisted_58 = [
    _hoisted_57
];
const _hoisted_59 = { key: 1 };
const _hoisted_60 = { class: "columns is-mobile" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Attachments", -1));
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_64 = { key: 5 };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Notarization", -1));
const _hoisted_66 = { key: 6 };
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Special Instructions", -1));
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Status History", -1));
const _hoisted_70 = { key: 7 };
const _hoisted_71 = { key: 8 };
import { Validations, useValidation } from "@/composables/useValidation";
import { doApiAction } from "@/core/api";
import { Core, ProfileTypes } from '@minicity/core';
import { enumKey, notifyError } from "@/core/utils";
import ApplicationStatusHistory from "@/features/applications/ApplicationStatusHistory.vue";
import ApplicationSupportDocumentUploadSection from "@/features/applications/ApplicationSupportDocumentUploadSection.vue";
import { onMounted, ref, watch } from "vue";
import { apiBirthRecords } from "../api";
import { watchQueryParam } from "@/composables/watchQueryParam";
import BirthRecordNotarizationTracker from "./BirthRecordNotarizationTracker.vue";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "Citizen Details";
    Tab["PARENTS"] = "Parents";
    Tab["ADOPTION"] = "Adoption";
    Tab["SIBLINGS"] = "Siblings";
    Tab["ID_AND_ATTACHMENTS"] = "ID & Attachments";
    Tab["NOTARIZATION"] = "Notarization";
    Tab["STATUS_HISTORY"] = "Status History";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'BirthRecordFormEditor',
    props: {
        request: {},
        onChangeRequiringReload: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const birthRecord = ref();
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        const tabAnnotations = ref({});
        const inProgressAction = ref(null);
        const originalState = ref(null);
        onMounted(() => {
            birthRecord.value = Object.assign({}, props.request);
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
            if (birthRecord.value.notarizationRequired) {
                tabAnnotations.value["NOTARIZATION"] = {
                    label: birthRecord.value.notarizedNotaryForm ? '✓' : '!',
                    class: birthRecord.value.notarizedNotaryForm ? 'is-info' : 'is-danger'
                };
            }
            originalState.value = props.request.birthState;
        });
        // Form validation
        const { areAllFieldsValid, validator } = useValidation();
        // Creates a new row of fields to add a sibling to the citizen requesting a birth record
        const addSibling = () => {
            if (!birthRecord.value.formData.siblings) {
                birthRecord.value.formData.siblings = [];
            }
            birthRecord.value.formData.siblings.push({ name: "", dateOfBirth: "2001-08-08" });
        };
        // Removes a citizen sibling from the formdata
        const removeSibling = (index) => {
            birthRecord.value.formData.siblings.splice(index, 1);
        };
        const saveBirthRecordForm = () => {
            if (!areAllFieldsValid.value) {
                notifyError("Please check for invalid form inputs");
                return;
            }
            doApiAction(inProgressAction, `saveForm`, "Birth Record Form updated", "Failed to update form", () => __awaiter(this, void 0, void 0, function* () {
                yield apiBirthRecords.updateForm(birthRecord.value.id, birthRecord.value.formData)
                    .then(resp => {
                    var _a;
                    if (resp.errorMessage) {
                        throw new Error(resp.errorMessage);
                    }
                    else {
                        birthRecord.value.formData = resp.formData;
                        if (((_a = resp.formData) === null || _a === void 0 ? void 0 : _a.birthState) != originalState.value) {
                            props.onChangeRequiringReload();
                        }
                    }
                });
            }));
        };
        return (_ctx, _cache) => {
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_CitizenBadge = _resolveComponent("CitizenBadge");
            const _component_router_link = _resolveComponent("router-link");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_SiteBadge = _resolveComponent("SiteBadge");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_FormDateField = _resolveComponent("FormDateField");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            return (birthRecord.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_TabsHeader, {
                        modelValue: activeTab.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeTab).value = $event)),
                        tabs: Tab,
                        annotations: tabAnnotations.value,
                        entityType: _unref(Core).EntityType['Birth Record'],
                        entityId: birthRecord.value.id
                    }, null, 8, ["modelValue", "annotations", "entityType", "entityId"]),
                    (activeTab.value == Tab.DETAILS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _hoisted_5,
                                    _createVNode(_component_router_link, {
                                        to: `/citizens/${birthRecord.value.citizen.id}`
                                    }, {
                                        default: _withCtx(() => [
                                            (birthRecord.value.citizen)
                                                ? (_openBlock(), _createBlock(_component_CitizenBadge, {
                                                    key: 0,
                                                    citizen: birthRecord.value.citizen
                                                }, null, 8, ["citizen"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["to"])
                                ]),
                                (birthRecord.value.isArchived)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _hoisted_7,
                                        _createTextVNode(" " + _toDisplayString(_unref(enumKey)(birthRecord.value.birthState, _unref(ProfileTypes).StateNotUnknown)), 1)
                                    ]))
                                    : (_openBlock(), _createBlock(_component_FormSelectField, {
                                        key: 1,
                                        label: "Birth State",
                                        modelValue: birthRecord.value.formData.birthState,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((birthRecord.value.formData.birthState) = $event)),
                                        options: _unref(ProfileTypes).StateNotUnknown
                                    }, null, 8, ["modelValue", "options"]))
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createVNode(_component_PartnerBadge, {
                                        partner: birthRecord.value.citizen.assignedCareProvider
                                    }, null, 8, ["partner"])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _hoisted_12,
                                    _createVNode(_component_SiteBadge, {
                                        site: birthRecord.value.citizen.assignedSite
                                    }, null, 8, ["site"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createVNode(_component_UserBadge, {
                                        user: birthRecord.value.citizen.assignedCaseworker
                                    }, null, 8, ["user"])
                                ])
                            ]),
                            (birthRecord.value.isArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_component_FormTextField, {
                                            label: "Birth Hospital *",
                                            modelValue: birthRecord.value.formData.birthHospital,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((birthRecord.value.formData.birthHospital) = $event)),
                                            validator: _unref(validator)(_unref(Validations).notEmpty)
                                        }, null, 8, ["modelValue", "validator"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Birth City *",
                                            modelValue: birthRecord.value.formData.birthCity,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((birthRecord.value.formData.birthCity) = $event)),
                                            validator: _unref(validator)(_unref(Validations).notEmpty)
                                        }, null, 8, ["modelValue", "validator"])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Birth District",
                                            modelValue: birthRecord.value.formData.birthDistrict,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((birthRecord.value.formData.birthDistrict) = $event)),
                                            options: _unref(ProfileTypes).BirthDistrict
                                        }, null, 8, ["modelValue", "options"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Birth County",
                                            modelValue: birthRecord.value.formData.birthCounty,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((birthRecord.value.formData.birthCounty) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_22,
                                    _createVNode(_component_SaveButton, {
                                        label: "Save Form",
                                        icon: "fa-save",
                                        action: "saveForm",
                                        inProgressAction: inProgressAction.value,
                                        onClick: _cache[6] || (_cache[6] = ($event) => (saveBirthRecordForm()))
                                    }, null, 8, ["inProgressAction"])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.PARENTS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (birthRecord.value.isArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_FormTextField, {
                                            label: "Father's Name",
                                            modelValue: birthRecord.value.formData.fatherName,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((birthRecord.value.formData.fatherName) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Name Before Marriage",
                                            modelValue: birthRecord.value.formData.fatherMaidenName,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((birthRecord.value.formData.fatherMaidenName) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Father's Birth State",
                                            modelValue: birthRecord.value.formData.fatherBirthState,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((birthRecord.value.formData.fatherBirthState) = $event)),
                                            options: _unref(ProfileTypes).State
                                        }, null, 8, ["modelValue", "options"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "County",
                                            modelValue: birthRecord.value.formData.fatherBirthCounty,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((birthRecord.value.formData.fatherBirthCounty) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "City",
                                            modelValue: birthRecord.value.formData.fatherBirthCity,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((birthRecord.value.formData.fatherBirthCity) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                        _createVNode(_component_FormTextField, {
                                            label: "Mother's Name",
                                            modelValue: birthRecord.value.formData.motherName,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((birthRecord.value.formData.motherName) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Name Before Marriage",
                                            modelValue: birthRecord.value.formData.motherMaidenName,
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((birthRecord.value.formData.motherMaidenName) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Mother's Birth State",
                                            modelValue: birthRecord.value.formData.motherBirthState,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((birthRecord.value.formData.motherBirthState) = $event)),
                                            options: _unref(ProfileTypes).State
                                        }, null, 8, ["modelValue", "options"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "County",
                                            modelValue: birthRecord.value.formData.motherBirthCounty,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((birthRecord.value.formData.motherBirthCounty) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "City",
                                            modelValue: birthRecord.value.formData.motherBirthCity,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((birthRecord.value.formData.motherBirthCity) = $event))
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Parents' Marital Status",
                                            modelValue: birthRecord.value.formData.parentsMaritalStatus,
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((birthRecord.value.formData.parentsMaritalStatus) = $event)),
                                            options: _unref(ProfileTypes).YesNoUnknown
                                        }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _hoisted_33,
                                    _createVNode(_component_SaveButton, {
                                        label: "Save Form",
                                        icon: "fa-save",
                                        action: "saveForm",
                                        inProgressAction: inProgressAction.value,
                                        onClick: _cache[18] || (_cache[18] = ($event) => (saveBirthRecordForm()))
                                    }, null, 8, ["inProgressAction"])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.ADOPTION)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            (birthRecord.value.isArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Adoption Status",
                                            modelValue: birthRecord.value.formData.adoptionStatus,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((birthRecord.value.formData.adoptionStatus) = $event)),
                                            options: _unref(ProfileTypes).YesNoUnknown
                                        }, null, 8, ["modelValue", "options"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Adopted Name",
                                            modelValue: birthRecord.value.formData.adoptedName,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((birthRecord.value.formData.adoptedName) = $event)),
                                            isDisabled: birthRecord.value.formData.adoptionStatus != 'YES'
                                        }, null, 8, ["modelValue", "isDisabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                        _createVNode(_component_FormTextField, {
                                            label: "Adoptive Father's Name",
                                            modelValue: birthRecord.value.formData.adoptedFatherName,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((birthRecord.value.formData.adoptedFatherName) = $event)),
                                            isDisabled: birthRecord.value.formData.adoptionStatus != 'YES'
                                        }, null, 8, ["modelValue", "isDisabled"]),
                                        _createVNode(_component_FormTextField, {
                                            label: "Adoptive Mother's Name",
                                            modelValue: birthRecord.value.formData.adoptedMotherName,
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((birthRecord.value.formData.adoptedMotherName) = $event)),
                                            isDisabled: birthRecord.value.formData.adoptionStatus != 'YES'
                                        }, null, 8, ["modelValue", "isDisabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Request Type re Adoption",
                                            modelValue: birthRecord.value.formData.adoptionRequestType,
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((birthRecord.value.formData.adoptionRequestType) = $event)),
                                            options: _unref(ProfileTypes).AdoptionRequestType,
                                            isDisabled: birthRecord.value.formData.adoptionStatus != 'YES'
                                        }, null, 8, ["modelValue", "options", "isDisabled"])
                                    ]),
                                    _hoisted_42,
                                    _createVNode(_component_SaveButton, {
                                        label: "Save Form",
                                        icon: "fa-save",
                                        action: "saveForm",
                                        inProgressAction: inProgressAction.value,
                                        onClick: _cache[24] || (_cache[24] = ($event) => (saveBirthRecordForm()))
                                    }, null, 8, ["inProgressAction"])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.SIBLINGS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (birthRecord.value.isArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(birthRecord.value.formData.siblings, (sibling, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "field is-grouped is-vertical-bottom"
                                        }, [
                                            _createElementVNode("div", _hoisted_48, [
                                                _createVNode(_component_FormTextField, {
                                                    label: "Sibling Name",
                                                    modelValue: sibling.name,
                                                    "onUpdate:modelValue": ($event) => ((sibling.name) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_49, [
                                                _createVNode(_component_FormDateField, {
                                                    label: "Sibling Birth Date",
                                                    modelValue: sibling.dateOfBirth,
                                                    "onUpdate:modelValue": ($event) => ((sibling.dateOfBirth) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (removeSibling(index)),
                                                    class: "button is-danger"
                                                }, _hoisted_53, 8, _hoisted_51)
                                            ])
                                        ]));
                                    }), 128)),
                                    _createElementVNode("button", {
                                        class: "button is-link is-small",
                                        onClick: _cache[25] || (_cache[25] = ($event) => (addSibling()))
                                    }, "Add Sibling +"),
                                    _hoisted_54,
                                    _createVNode(_component_SaveButton, {
                                        label: "Save Form",
                                        icon: "fa-save",
                                        action: "saveForm",
                                        inProgressAction: inProgressAction.value,
                                        onClick: _cache[26] || (_cache[26] = ($event) => (saveBirthRecordForm()))
                                    }, null, 8, ["inProgressAction"])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.ID_AND_ATTACHMENTS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            (birthRecord.value.isArchived)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                                : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                        _createVNode(_component_FormSelectField, {
                                            label: "Voting Intent",
                                            modelValue: birthRecord.value.formData.votingIntent,
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((birthRecord.value.formData.votingIntent) = $event)),
                                            options: _unref(ProfileTypes).VotingIntent,
                                            validator: _unref(validator)(_unref(Validations).notEmpty)
                                        }, null, 8, ["modelValue", "options", "validator"]),
                                        _createVNode(_component_FormSelectField, {
                                            label: "Possessed ID Types",
                                            modelValue: birthRecord.value.formData.possessedIdTypes,
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((birthRecord.value.formData.possessedIdTypes) = $event)),
                                            options: _unref(ProfileTypes).PossessedIdTypes
                                        }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _hoisted_61,
                                    _hoisted_62,
                                    _createVNode(ApplicationSupportDocumentUploadSection, {
                                        title: "Cover Pages",
                                        documents: birthRecord.value.coverPages,
                                        upload: (file) => _unref(apiBirthRecords).uploadCoverPage(birthRecord.value.id, file).then((doc) => birthRecord.value.coverPages.push(doc)),
                                        delete: (id) => _unref(apiBirthRecords).deleteAttachment(birthRecord.value.id, id).then(() => birthRecord.value.coverPages = birthRecord.value.coverPages.filter(d => d.id != id)),
                                        getViewLink: (id) => _unref(apiBirthRecords).getAttachmentViewLink(birthRecord.value.id, id)
                                    }, null, 8, ["documents", "upload", "delete", "getViewLink"]),
                                    _createVNode(ApplicationSupportDocumentUploadSection, {
                                        title: "Supporting ID / Documentation",
                                        documents: birthRecord.value.supportDocuments,
                                        upload: (file) => _unref(apiBirthRecords).uploadSupportingDocument(birthRecord.value.id, file).then((doc) => birthRecord.value.supportDocuments.push(doc)),
                                        delete: (id) => _unref(apiBirthRecords).deleteAttachment(birthRecord.value.id, id).then(() => birthRecord.value.supportDocuments = birthRecord.value.supportDocuments.filter(d => d.id != id)),
                                        getViewLink: (id) => _unref(apiBirthRecords).getAttachmentViewLink(birthRecord.value.id, id)
                                    }, null, 8, ["documents", "upload", "delete", "getViewLink"]),
                                    _hoisted_63,
                                    _createVNode(_component_SaveButton, {
                                        label: "Save Form",
                                        icon: "fa-save",
                                        action: "saveForm",
                                        inProgressAction: inProgressAction.value,
                                        onClick: _cache[29] || (_cache[29] = ($event) => (saveBirthRecordForm()))
                                    }, null, 8, ["inProgressAction"])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.NOTARIZATION)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _hoisted_65,
                            _createVNode(BirthRecordNotarizationTracker, { request: birthRecord.value }, null, 8, ["request"])
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.STATUS_HISTORY)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("p", null, _toDisplayString(birthRecord.value.instructions.length == 0 ? "None" : birthRecord.value.instructions), 1),
                            _hoisted_68,
                            _hoisted_69,
                            _createVNode(ApplicationStatusHistory, {
                                statusHistory: birthRecord.value.statusHistory
                            }, null, 8, ["statusHistory"])
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.COMMENTS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createVNode(_component_CommentSection, {
                                getComments: () => _unref(apiBirthRecords).getComments(birthRecord.value.id),
                                addComment: (message, attachments, notifyCaseworker) => _unref(apiBirthRecords).addComment(birthRecord.value.id, message, attachments, notifyCaseworker),
                                getAttachmentViewLink: (commentId, attachmentId) => _unref(apiBirthRecords).getCommentAttachmentViewLink(birthRecord.value.id, commentId, attachmentId)
                            }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                        ]))
                        : _createCommentVNode("", true),
                    (activeTab.value == Tab.TASKS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createVNode(_component_TaskSection, {
                                allowShowAll: "",
                                getTasks: () => _unref(apiBirthRecords).getTasks(props.request.id),
                                addTask: (audience, message) => _unref(apiBirthRecords).addTask(birthRecord.value.id, audience, message)
                            }, null, 8, ["getTasks", "addTask"])
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
